import React from "react";
import ErrorLabel from "@insightfulscience/atomic-react/ErrorLabel";
import { idX } from "@insightfulscience/shared-utils/fn";

const renderError = (error, render = idX) =>
	error &&
	(Array.isArray(error) ? (
		<ErrorLabel>
			{error.map(e => (
				<ErrorLabel.Text key={e}>{render(e)}</ErrorLabel.Text>
			))}
		</ErrorLabel>
	) : (
		<ErrorLabel>
			<ErrorLabel.Text>{render(error)}</ErrorLabel.Text>
		</ErrorLabel>
	));

export default renderError;
